import { useLocation } from '@reach/router';
import { navigate } from 'gatsby';
import { useEffect, useState } from 'react';
import { scrollIntoView } from 'seamless-scroll-polyfill';

export type LocationType = Pick<
  URL,
  'hash' | 'pathname' | 'search' | 'searchParams'
>;
export type useLocationType = () => [LocationType, (url: string) => void];

// Port of @amazeelabs/bridge-gatsby.
export const useGatsbyLocation: useLocationType = () => {
  const location = useLocation();
  const [updatedSearch, setUpdatedSearch] = useState('');
  const [updatedHash, setUpdatedHash] = useState('');
  useEffect(() => {
    console.log('useGatsbyLocation useEffect', location.hash);
    if (location.search) setUpdatedSearch(location.search);
    if (location.hash) setUpdatedHash(location.hash);
  }, [location.search, location.hash]);

  return [
    {
      ...location,
      search: updatedSearch,
      hash: updatedHash,
      searchParams: new URLSearchParams(updatedSearch),
    },
    navigate,
  ];
};

export const scrollToHeroEnd = () => {
  if (typeof document !== 'undefined') {
    const heroSectionEnd = document.getElementsByClassName('hero-section-end');
    if (heroSectionEnd[0]) {
      // We use a polyfill for scrollIntoView() since recent versions of Safari
      // browsers have bugs in supporting the scroll behaviour.
      // See also: https://developer.apple.com/forums/thread/703294
      scrollIntoView(
        heroSectionEnd[0],
        { behavior: 'smooth' },
        { forcePolyfill: true },
      );
    }
  }
};

export const scrollToHash = () => {
  if (typeof document !== 'undefined') {
    // Delay the scroll for a bit, since sometimes the elements are not yet
    // rendered. This happens especially after a redirect (using gatsby
    // navigate) is done.
    setTimeout(() => {
      const hash = document.location.hash;
      if (hash === '') {
        return;
      }
      const hashElement = document.getElementById(hash.substring(1));
      if (hashElement) {
        // Same as in scrollToHeroEnd(), we use a polyfill for scrollIntoView()
        // since recent versions of Safari browsers have bugs in supporting the
        // scroll behaviour.
        // See also: https://developer.apple.com/forums/thread/703294
        scrollIntoView(
          hashElement,
          { behavior: 'smooth' },
          { forcePolyfill: true },
        );
      }
    }, 500);
  }
};

export const scrollToLocationHash = (hash: string) => {
  if (typeof document !== 'undefined') {
    if (hash === '') {
      return;
    }
    const hashElement = document.getElementById(hash.substring(1));
    if (hashElement) {
      console.log('scrollToLocationHash', hashElement);
      // Same as in scrollToHeroEnd(), we use a polyfill for scrollIntoView()
      // since recent versions of Safari browsers have bugs in supporting the
      // scroll behaviour.
      // See also: https://developer.apple.com/forums/thread/703294
      scrollIntoView(
        hashElement,
        {behavior: 'smooth'},
        {forcePolyfill: true},
      );
    }
  }
};
